<template>
  <div
    aria-hidden="true"
    class="onboarding-modal modal fade animated"
    id="detalleRecepcion"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-lg modal-centered" role="document">
      <div class="modal-content text-center" style="width: 98%">
        <button
          aria-label="Close"
          class="close"
          data-dismiss="modal"
          ref="cerrarModal"
          type="button"
        >
          <span class="close-label">Cancelar</span>
          <span class="os-icon os-icon-close"></span>
        </button>
        <div class="onboarding">
          <div
            class="onboarding-content with-gradient"
            style="
              padding-left: 0.5px;
              padding-right: 0.5px;
              padding-bottom: 0px;
            "
          >
            <div class="text-center"></div>
            <form>
              <div class="row">
                <div class="col-md-12">
                  <div class="projects-list">
                    <div class="project-box" style="cursor: pointer">
                      <div
                        style="padding-left: 10px; padding-right: 10px"
                        v-if="factura_d"
                      >
                        <div class="project-title text-center">
                          <h5>{{ get_first(factura_d).producto.sku }}</h5>
                          <h3>{{ get_first(factura_d).producto.nombre }}</h3>
                        </div>

                        <div class="col-12">
                          <div class="el-tablo highlight text-left">
                            <div class="table-responsive">
                              <table class="table table-compact smaller">
                                <thead>
                                  <tr>
                                    <th class="text-right">Fardos</th>
                                    <th>Unidad Medida</th>
                                    <th class="text-right">Cant Unidades</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="fardo in fardos"
                                    v-bind:key="fardo.id"
                                  >
                                    <td class="text-right">
                                      {{ fardo.cantidad_um }}
                                    </td>
                                    <td>{{ fardo.unidad_medida__nombre }}</td>
                                    <td
                                      class="text-right"
                                      style="padding-right: 10px"
                                    >
                                      {{ fardo.unidades_totales }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="table-scroll-container">
                          <table class="table table-compact smaller mb-0 h-90">
                          <thead>
                            <tr>
                              <th>Total</th>
                              <th>Ing</th>
                              <th>Mal</th>
                              <th>OC</th>
                              <th>Precio</th>
                              <th>Unitario</th>
                            </tr>
                          </thead>
                          <tbody
                            v-for="current in factura_d"
                            v-bind:key="current.id"
                            :style="{
                              'background-color': colorize_tdoby_tipo(current),
                            }"
                          >
                            <tr>
                              <td>{{ current.cantidad_total }}</td>
                              <td>{{ current.cantidad }}</td>
                              <td>{{ current.cantidad_mal_estado }}</td>
                              <td v-if="!current.orden_compra_d">0</td>
                              <td v-if="current.orden_compra_d">
                                {{ current.orden_compra_d.cantidad }}
                              </td>
                              <td>Q{{ (Number(current.precio_unidad_real) * Number(current.cantidad_total)).toFixed(2) }}</td>
                              <td>Q{{ current.precio_unidad_real }}</td>
                            </tr>
                            <tr>
                              <td style="border-top: none" colspan="3">
                                <div
                                  class="text-bold text-success"
                                  v-if="current.estado == 'A'"
                                >
                                  {{ current.estado_str }}
                                </div>
                                <div
                                  class="text-bold text-info"
                                  v-if="current.estado == 'B'"
                                >
                                  {{ current.estado_str }}
                                </div>
                                <div
                                  class="text-bold text-secondary"
                                  v-if="current.estado == 'P'"
                                >
                                  {{ current.estado_str }}
                                </div>
                                <div
                                  class="text-bold text-danger"
                                  v-if="current.estado == 'N'"
                                >
                                  {{ current.estado_str }}
                                </div>
                                <div
                                  class="text-bold text-info"
                                  v-if="current.estado == 'S'"
                                >
                                  {{ current.estado_str }}
                                </div>
                                <div
                                  class="text-bold text-info"
                                  v-if="current.estado == 'U'"
                                >
                                  {{ current.estado_str }}
                                </div>
                              </td>
                              <td style="border-top: none" colspan="3">
                                <small v-if="current.tarima"
                                  >{{ current.tarima }}
                                </small>
                                <small v-if="!current.tarima">Sin Tarima</small>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: ["factura_d", "fardos"],
  computed: {},
  mounted() {},
  methods: {
    get_first: function (current) {
      let self = this;
      return self.factura_d[0];
    },
    colorize_tdoby_tipo: function (det) {
      if (det.estado == "N") {
        return "#ff000029";
      }
      if (det.estado == "P") {
        return "#ffff0021";
      }
      if (det.estado == "B") {
        return "#00800021";
      }
      return "";
    },
  },
};
</script>

<style scoped>
.table-scroll-container {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 4px;
}

.table-scroll-container thead th {
  position: sticky;
  top: 0;
  background-color: #f8f9fa;
  z-index: 2;
  box-shadow: inset 0 -1px 0 #e9ecef;
}
</style>
